import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { Box, CircularProgress } from '@mui/material'

const ProtectedRoute = ({ children, requireVerification = true }) => {
  const { currentUser, loading, isEmailVerified, accountLocked, lockMessage } = useAuth()

  // Show loading spinner while authentication is being checked
  if (loading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh'>
        <CircularProgress />
      </Box>
    )
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    return <Navigate to='/login' />
  }

  // Redirect to account locked page if account is locked
  if (accountLocked) {
    // For now, redirect to the login page with a query parameter
    return <Navigate to={`/login?locked=true&message=${encodeURIComponent(lockMessage)}`} />
  }

  // Redirect to email verification page if email not verified and verification is required
  if (requireVerification && !isEmailVerified) {
    return <Navigate to='/verify-email' />
  }

  // Render the protected content
  return children
}

export default ProtectedRoute
